/* js/pages/ParcoursPage.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { db } from '../Db';
import { onMount, onDestroy } from 'svelte';
import { appRouter } from '../appRouter.js';
import Header from '../components/Header.svelte';
import MapLibre from '../components/MapLibre.svelte';
import ParcoursPath from '../components/ParcoursPath.svelte';
import UserMarkerLibre from '../components/UserMarkerLibre.svelte';
import SpotMarkerLibre from '../components/SpotMarkerLibre.svelte';
import ShareButton from '../components/ShareButton.svelte';
import computeUrl from '../url';
import { Button, Ripple } from 'svelte-mui';
import HyperButton from '../components/HyperButton.svelte';
import MenuModal from '../components/MenuModal.svelte';
import * as animateScroll from "svelte-scrollto";
import GeoLocationStartButton from '../components/GeoLocationStartButton.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import {
	computeBounds,
	getBbox,
	lineFeatureCollectionFromPoints
} from '../geoUtils';

import { flyToProvider } from '../providers';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[24] = list[i];
	child_ctx[26] = i;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[27] = list[i];
	child_ctx[26] = i;
	return child_ctx;
}

// (140:0) {#if parcours}
function create_if_block_3(ctx) {
	let h1;
	let t0_value = /*parcours*/ ctx[1].title + "";
	let t0;
	let t1;
	let img;
	let img_src_value;
	let t2;
	let html_tag;
	let raw_value = /*parcours*/ ctx[1].html + "";
	let t3;
	let hyperbutton;
	let t4;
	let br0;
	let br1;
	let t5;
	let div;
	let maplibre;
	let t6;
	let h2;
	let t8;
	let t9;
	let t10;
	let t11;
	let if_block2_anchor;
	let current;

	hyperbutton = new HyperButton({
			props: {
				class: "button",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	hyperbutton.$on("click", /*onStart*/ ctx[6]);

	maplibre = new MapLibre({
			props: {
				onLoad: /*onMapLoaded*/ ctx[7],
				interactive: false,
				pitch: "0",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	let each_value = /*parcours*/ ctx[1].steps;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block0 = /*parcours*/ ctx[1].events_html && create_if_block_6(ctx);
	let if_block1 = /*parcours*/ ctx[1].bonus_html && create_if_block_5(ctx);
	let if_block2 = /*parcours*/ ctx[1].bibliography_html && create_if_block_4(ctx);

	return {
		c() {
			h1 = element("h1");
			t0 = text(t0_value);
			t1 = space();
			img = element("img");
			t2 = space();
			html_tag = new HtmlTag();
			t3 = space();
			create_component(hyperbutton.$$.fragment);
			t4 = space();
			br0 = element("br");
			br1 = element("br");
			t5 = space();
			div = element("div");
			create_component(maplibre.$$.fragment);
			t6 = space();
			h2 = element("h2");
			h2.textContent = "Les haltes";
			t8 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t9 = space();
			if (if_block0) if_block0.c();
			t10 = space();
			if (if_block1) if_block1.c();
			t11 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*parcours*/ ctx[1].media.coverImage))) attr(img, "src", img_src_value);
			attr(img, "alt", "cover image");
			attr(img, "class", "svelte-851efv");
			html_tag.a = t3;
			attr(div, "class", "map-container svelte-851efv");
			attr(h2, "class", "section-haltes");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, img, anchor);
			insert(target, t2, anchor);
			html_tag.m(raw_value, target, anchor);
			insert(target, t3, anchor);
			mount_component(hyperbutton, target, anchor);
			insert(target, t4, anchor);
			insert(target, br0, anchor);
			insert(target, br1, anchor);
			insert(target, t5, anchor);
			insert(target, div, anchor);
			mount_component(maplibre, div, null);
			insert(target, t6, anchor);
			insert(target, h2, anchor);
			insert(target, t8, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, t9, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t10, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t11, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*parcours*/ 2) && t0_value !== (t0_value = /*parcours*/ ctx[1].title + "")) set_data(t0, t0_value);

			if (!current || dirty & /*parcours*/ 2 && !src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*parcours*/ ctx[1].media.coverImage))) {
				attr(img, "src", img_src_value);
			}

			if ((!current || dirty & /*parcours*/ 2) && raw_value !== (raw_value = /*parcours*/ ctx[1].html + "")) html_tag.p(raw_value);
			const hyperbutton_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				hyperbutton_changes.$$scope = { dirty, ctx };
			}

			hyperbutton.$set(hyperbutton_changes);
			const maplibre_changes = {};

			if (dirty & /*$$scope, haltePoints, parcoursPath, parcours, mapIsReady*/ 536870958) {
				maplibre_changes.$$scope = { dirty, ctx };
			}

			maplibre.$set(maplibre_changes);

			if (dirty & /*appRouter, params, parcours*/ 3) {
				each_value = /*parcours*/ ctx[1].steps;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(t9.parentNode, t9);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*parcours*/ ctx[1].events_html) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(t10.parentNode, t10);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*parcours*/ ctx[1].bonus_html) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_5(ctx);
					if_block1.c();
					if_block1.m(t11.parentNode, t11);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*parcours*/ ctx[1].bibliography_html) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_4(ctx);
					if_block2.c();
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(hyperbutton.$$.fragment, local);
			transition_in(maplibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hyperbutton.$$.fragment, local);
			transition_out(maplibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(img);
			if (detaching) detach(t2);
			if (detaching) html_tag.d();
			if (detaching) detach(t3);
			destroy_component(hyperbutton, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(br0);
			if (detaching) detach(br1);
			if (detaching) detach(t5);
			if (detaching) detach(div);
			destroy_component(maplibre);
			if (detaching) detach(t6);
			if (detaching) detach(h2);
			if (detaching) detach(t8);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t9);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t10);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t11);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

// (152:4) <HyperButton class="button" on:click={onStart} >
function create_default_slot_7(ctx) {
	let t;

	return {
		c() {
			t = text("Commencer le parcours");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (161:12) {#if parcoursPath && mapIsReady}
function create_if_block_7(ctx) {
	let parcourspath;
	let t;
	let each_1_anchor;
	let current;

	parcourspath = new ParcoursPath({
			props: {
				pathData: /*parcoursPath*/ ctx[3],
				parcoursSlug: /*parcours*/ ctx[1].slug,
				pathColor: "#222",
				lineWidth: 6
			}
		});

	let each_value_1 = /*haltePoints*/ ctx[5];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			create_component(parcourspath.$$.fragment);
			t = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			mount_component(parcourspath, target, anchor);
			insert(target, t, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const parcourspath_changes = {};
			if (dirty & /*parcoursPath*/ 8) parcourspath_changes.pathData = /*parcoursPath*/ ctx[3];
			if (dirty & /*parcours*/ 2) parcourspath_changes.parcoursSlug = /*parcours*/ ctx[1].slug;
			parcourspath.$set(parcourspath_changes);

			if (dirty & /*haltePoints, gotoHalte*/ 544) {
				each_value_1 = /*haltePoints*/ ctx[5];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(parcourspath.$$.fragment, local);

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(parcourspath.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_component(parcourspath, detaching);
			if (detaching) detach(t);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (163:16) {#each haltePoints as haltePoint, index}
function create_each_block_1(ctx) {
	let spotmarkerlibre;
	let current;

	function requestSelection_handler() {
		return /*requestSelection_handler*/ ctx[12](/*index*/ ctx[26]);
	}

	spotmarkerlibre = new SpotMarkerLibre({
			props: {
				id: /*index*/ ctx[26],
				isLast: /*index*/ ctx[26] == /*haltePoints*/ ctx[5].length - 1,
				coords: /*haltePoint*/ ctx[27],
				clickable: true,
				zIndex: /*haltePoints*/ ctx[5].length - /*index*/ ctx[26]
			}
		});

	spotmarkerlibre.$on("requestSelection", requestSelection_handler);

	return {
		c() {
			create_component(spotmarkerlibre.$$.fragment);
		},
		m(target, anchor) {
			mount_component(spotmarkerlibre, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const spotmarkerlibre_changes = {};
			if (dirty & /*haltePoints*/ 32) spotmarkerlibre_changes.isLast = /*index*/ ctx[26] == /*haltePoints*/ ctx[5].length - 1;
			if (dirty & /*haltePoints*/ 32) spotmarkerlibre_changes.coords = /*haltePoint*/ ctx[27];
			if (dirty & /*haltePoints*/ 32) spotmarkerlibre_changes.zIndex = /*haltePoints*/ ctx[5].length - /*index*/ ctx[26];
			spotmarkerlibre.$set(spotmarkerlibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(spotmarkerlibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(spotmarkerlibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(spotmarkerlibre, detaching);
		}
	};
}

// (158:8) <MapLibre onLoad={onMapLoaded} interactive={false} pitch=0>
function create_default_slot_6(ctx) {
	let usermarkerlibre;
	let t0;
	let geolocationstartbutton;
	let t1;
	let if_block_anchor;
	let current;
	usermarkerlibre = new UserMarkerLibre({});
	geolocationstartbutton = new GeoLocationStartButton({});
	let if_block = /*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[2] && create_if_block_7(ctx);

	return {
		c() {
			create_component(usermarkerlibre.$$.fragment);
			t0 = space();
			create_component(geolocationstartbutton.$$.fragment);
			t1 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(usermarkerlibre, target, anchor);
			insert(target, t0, anchor);
			mount_component(geolocationstartbutton, target, anchor);
			insert(target, t1, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*parcoursPath*/ ctx[3] && /*mapIsReady*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*parcoursPath, mapIsReady*/ 12) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_7(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(usermarkerlibre.$$.fragment, local);
			transition_in(geolocationstartbutton.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(usermarkerlibre.$$.fragment, local);
			transition_out(geolocationstartbutton.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(usermarkerlibre, detaching);
			if (detaching) detach(t0);
			destroy_component(geolocationstartbutton, detaching);
			if (detaching) detach(t1);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (179:4) {#each parcours.steps as step, index}
function create_each_block(ctx) {
	let a;
	let t_value = `${/*index*/ ctx[26] + 1}. ${/*step*/ ctx[24].title}` + "";
	let t;
	let a_href_value;

	return {
		c() {
			a = element("a");
			t = text(t_value);
			attr(a, "href", a_href_value = appRouter.normalizePath(`/parcours/${/*params*/ ctx[0].slug}/halte/${/*step*/ ctx[24].slug}`));
			attr(a, "class", "svelte-851efv");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, t);
		},
		p(ctx, dirty) {
			if (dirty & /*parcours*/ 2 && t_value !== (t_value = `${/*index*/ ctx[26] + 1}. ${/*step*/ ctx[24].title}` + "")) set_data(t, t_value);

			if (dirty & /*params, parcours*/ 3 && a_href_value !== (a_href_value = appRouter.normalizePath(`/parcours/${/*params*/ ctx[0].slug}/halte/${/*step*/ ctx[24].slug}`))) {
				attr(a, "href", a_href_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (183:4) {#if parcours.events_html}
function create_if_block_6(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*parcours*/ ctx[1].events_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Les évenements";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-events");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*parcours*/ 2 && raw_value !== (raw_value = /*parcours*/ ctx[1].events_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (190:4) {#if parcours.bonus_html}
function create_if_block_5(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*parcours*/ ctx[1].bonus_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Les bonus";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-bonus");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*parcours*/ 2 && raw_value !== (raw_value = /*parcours*/ ctx[1].bonus_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (197:4) {#if parcours.bibliography_html}
function create_if_block_4(ctx) {
	let section;
	let h2;
	let t1;
	let html_tag;
	let raw_value = /*parcours*/ ctx[1].bibliography_html + "";

	return {
		c() {
			section = element("section");
			h2 = element("h2");
			h2.textContent = "Bibliographie";
			t1 = space();
			html_tag = new HtmlTag();
			html_tag.a = null;
			attr(section, "class", "section-bibliography");
		},
		m(target, anchor) {
			insert(target, section, anchor);
			append(section, h2);
			append(section, t1);
			html_tag.m(raw_value, section);
		},
		p(ctx, dirty) {
			if (dirty & /*parcours*/ 2 && raw_value !== (raw_value = /*parcours*/ ctx[1].bibliography_html + "")) html_tag.p(raw_value);
		},
		d(detaching) {
			if (detaching) detach(section);
		}
	};
}

// (208:8) <Button on:click={() => gotoSection('.section-map')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_5(ctx) {
	let t;

	return {
		c() {
			t = text("carte");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (211:8) <Button on:click={() => gotoSection('.section-haltes')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_4(ctx) {
	let t;

	return {
		c() {
			t = text("Haltes");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (215:8) {#if parcours.events_html}
function create_if_block_2(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_4*/ ctx[15]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (216:12) <Button on:click={() => gotoSection('.section-events')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = text("événements");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (220:8) {#if parcours.bonus_html}
function create_if_block_1(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_5*/ ctx[16]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (221:12) <Button on:click={() => gotoSection('.section-bonus')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_2(ctx) {
	let t;

	return {
		c() {
			t = text("bonus");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (225:8) {#if parcours.bibliography_html}
function create_if_block(ctx) {
	let button;
	let t;
	let div;
	let current;

	button = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	button.$on("click", /*click_handler_6*/ ctx[17]);

	return {
		c() {
			create_component(button.$$.fragment);
			t = space();
			div = element("div");
			attr(div, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			insert(target, t, anchor);
			insert(target, div, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

// (226:12) <Button on:click={() => gotoSection('.section-bibliography')} color="#eeeeee" unelevated fullWidth>
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("bibliographie");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (206:4) <MenuModal bind:open={sectionModalVisible}>
function create_default_slot(ctx) {
	let button0;
	let t0;
	let div0;
	let t1;
	let button1;
	let t2;
	let div1;
	let t3;
	let t4;
	let t5;
	let if_block2_anchor;
	let current;

	button0 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*click_handler_2*/ ctx[13]);

	button1 = new Button({
			props: {
				color: "#eeeeee",
				unelevated: true,
				fullWidth: true,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*click_handler_3*/ ctx[14]);
	let if_block0 = /*parcours*/ ctx[1].events_html && create_if_block_2(ctx);
	let if_block1 = /*parcours*/ ctx[1].bonus_html && create_if_block_1(ctx);
	let if_block2 = /*parcours*/ ctx[1].bibliography_html && create_if_block(ctx);

	return {
		c() {
			create_component(button0.$$.fragment);
			t0 = space();
			div0 = element("div");
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			div1 = element("div");
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			if (if_block1) if_block1.c();
			t5 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
			attr(div0, "class", "spacer");
			attr(div1, "class", "spacer");
		},
		m(target, anchor) {
			mount_component(button0, target, anchor);
			insert(target, t0, anchor);
			insert(target, div0, anchor);
			insert(target, t1, anchor);
			mount_component(button1, target, anchor);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			insert(target, t3, anchor);
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t4, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, t5, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const button0_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);
			const button1_changes = {};

			if (dirty & /*$$scope*/ 536870912) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);

			if (/*parcours*/ ctx[1].events_html) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*parcours*/ 2) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t4.parentNode, t4);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*parcours*/ ctx[1].bonus_html) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*parcours*/ 2) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t5.parentNode, t5);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*parcours*/ ctx[1].bibliography_html) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*parcours*/ 2) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			destroy_component(button0, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			destroy_component(button1, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			if (detaching) detach(t3);
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t4);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t5);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div2;
	let div0;
	let ripple0;
	let t1;
	let t2;
	let div1;
	let ripple1;
	let t3;
	let img;
	let img_src_value;
	let t4;
	let sharebutton;
	let t5;
	let div5;
	let div3;
	let t6;
	let t7;
	let menumodal;
	let updating_open;
	let t8;
	let div4;
	let current;
	let mounted;
	let dispose;
	header = new Header({ props: { title: "Parcours" } });
	ripple0 = new Ripple({ props: { center: true } });
	ripple1 = new Ripple({ props: { center: true } });
	sharebutton = new ShareButton({ props: { url: computeUrl() } });
	let if_block = /*parcours*/ ctx[1] && create_if_block_3(ctx);

	function menumodal_open_binding(value) {
		/*menumodal_open_binding*/ ctx[18](value);
	}

	let menumodal_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*sectionModalVisible*/ ctx[4] !== void 0) {
		menumodal_props.open = /*sectionModalVisible*/ ctx[4];
	}

	menumodal = new MenuModal({ props: menumodal_props });
	binding_callbacks.push(() => bind(menumodal, 'open', menumodal_open_binding));

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(ripple0.$$.fragment);
			t1 = text("EN AVOIR PLUS");
			t2 = space();
			div1 = element("div");
			create_component(ripple1.$$.fragment);
			t3 = space();
			img = element("img");
			t4 = space();
			create_component(sharebutton.$$.fragment);
			t5 = space();
			div5 = element("div");
			div3 = element("div");
			t6 = space();
			if (if_block) if_block.c();
			t7 = space();
			create_component(menumodal.$$.fragment);
			t8 = space();
			div4 = element("div");
			attr(div0, "class", "en-avoir-plus bottom-centered box-shadow");
			if (!src_url_equal(img.src, img_src_value = "/_icons/info.svg")) attr(img, "src", img_src_value);
			attr(img, "class", "svelte-851efv");
			attr(div1, "class", "fab-button small bottom-left box-shadow");
			attr(div2, "class", "footer gradient");
			attr(div3, "class", "headspacer");
			attr(div4, "class", "footerspacer");
			attr(div5, "class", "column");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div2, anchor);
			append(div2, div0);
			mount_component(ripple0, div0, null);
			append(div0, t1);
			append(div2, t2);
			append(div2, div1);
			mount_component(ripple1, div1, null);
			append(div1, t3);
			append(div1, img);
			append(div2, t4);
			mount_component(sharebutton, div2, null);
			insert(target, t5, anchor);
			insert(target, div5, anchor);
			append(div5, div3);
			append(div5, t6);
			if (if_block) if_block.m(div5, null);
			append(div5, t7);
			mount_component(menumodal, div5, null);
			append(div5, t8);
			append(div5, div4);
			current = true;

			if (!mounted) {
				dispose = [
					listen(div0, "click", /*click_handler*/ ctx[10]),
					listen(div1, "click", /*click_handler_1*/ ctx[11])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*parcours*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*parcours*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div5, t7);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const menumodal_changes = {};

			if (dirty & /*$$scope, parcours*/ 536870914) {
				menumodal_changes.$$scope = { dirty, ctx };
			}

			if (!updating_open && dirty & /*sectionModalVisible*/ 16) {
				updating_open = true;
				menumodal_changes.open = /*sectionModalVisible*/ ctx[4];
				add_flush_callback(() => updating_open = false);
			}

			menumodal.$set(menumodal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(ripple0.$$.fragment, local);
			transition_in(ripple1.$$.fragment, local);
			transition_in(sharebutton.$$.fragment, local);
			transition_in(if_block);
			transition_in(menumodal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(ripple0.$$.fragment, local);
			transition_out(ripple1.$$.fragment, local);
			transition_out(sharebutton.$$.fragment, local);
			transition_out(if_block);
			transition_out(menumodal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div2);
			destroy_component(ripple0);
			destroy_component(ripple1);
			destroy_component(sharebutton);
			if (detaching) detach(t5);
			if (detaching) detach(div5);
			if (if_block) if_block.d();
			destroy_component(menumodal);
			mounted = false;
			run_all(dispose);
		}
	};
}

function onGeoLocationStarted() {
	
}

function instance($$self, $$props, $$invalidate) {
	let { params } = $$props;
	let parcours;
	let mapIsReady = false;
	let parcoursPath;
	let parcoursPoints = null;
	let sectionModalVisible = false;
	let userPosition = geoLocationManager.currentCoords;
	let haltePoints;

	onMount(() => {
		// console.log(params);
		$$invalidate(1, parcours = db.getParcoursWithSlug(params.slug));

		$$invalidate(5, haltePoints = db.getHalteCoordsForParcours(params.slug));
	});

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
	});

	function onGeoLocationUpdate(event) {
		// console.log("geo update on path page", event.value);
		userPosition = event.value;

		flyToParcoursAndUser();
	}

	function onGeoLocationStopped() {
		userPosition = null;
		flyToParcoursAndUser();
	}

	function flyToParcoursAndUser() {
		let points = parcoursPoints.slice();

		if (userPosition && geoLocationManager.isStarted) {
			points.push(userPosition.coords);
		}

		const bbox = getBbox(points);
		const flyToOptions = { bounds: bbox, padding: 30 };
		flyToProvider.provide(flyToOptions);
	}

	function onStart() {
		appRouter.show(`/parcours/${parcours.slug}/en_chemin/${parcours.steps[0].slug}`);
	}

	async function onMapLoaded() {
		$$invalidate(2, mapIsReady = true);
		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);

		if (parcours.media.path) {
			$$invalidate(3, parcoursPath = await db.getParcoursPath(parcours.slug));
		} else {
			$$invalidate(3, parcoursPath = JSON.parse(lineFeatureCollectionFromPoints(haltePoints)));
		}

		parcoursPoints = parcoursPath.features.find(feature => feature.geometry.type == "LineString").geometry.coordinates;
		flyToParcoursAndUser();
	}

	function gotoSection(query) {
		$$invalidate(4, sectionModalVisible = false);
		const offset = -100;
		animateScroll.scrollTo({ element: query, offset, duration: 700 });
	}

	function gotoHalte(halteIndex) {
		const halteSlug = parcours.steps.find(step => step.idx === halteIndex).slug;
		appRouter.show(`/parcours/${params.slug}/halte/${halteSlug}`);
	}

	const click_handler = () => $$invalidate(4, sectionModalVisible = true);
	const click_handler_1 = () => appRouter.show("/a_propos");
	const requestSelection_handler = index => gotoHalte(index);
	const click_handler_2 = () => gotoSection('.section-map');
	const click_handler_3 = () => gotoSection('.section-haltes');
	const click_handler_4 = () => gotoSection('.section-events');
	const click_handler_5 = () => gotoSection('.section-bonus');
	const click_handler_6 = () => gotoSection('.section-bibliography');

	function menumodal_open_binding(value) {
		sectionModalVisible = value;
		$$invalidate(4, sectionModalVisible);
	}

	$$self.$$set = $$props => {
		if ('params' in $$props) $$invalidate(0, params = $$props.params);
	};

	return [
		params,
		parcours,
		mapIsReady,
		parcoursPath,
		sectionModalVisible,
		haltePoints,
		onStart,
		onMapLoaded,
		gotoSection,
		gotoHalte,
		click_handler,
		click_handler_1,
		requestSelection_handler,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		click_handler_6,
		menumodal_open_binding
	];
}

class ParcoursPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { params: 0 });
	}
}

export default ParcoursPage;